import React from 'react';
import { Trans } from 'react-i18next';
import { useHistory, useRouteMatch } from 'react-router';

import ModalToBody from '../../../../base/ModalToBody';
import { MaterialByDayForm } from './MaterialByDayForm';

export const EventMaterialDetails = () => {
  const match = useRouteMatch<{ materialId?: string; id?: string }>();
  const {
    params: { materialId, id },
  } = match;
  const history = useHistory();
  let { path, url } = useRouteMatch();

  if (!materialId || !id) {
    return <div>Missing eventId or materialId.</div>;
  }

  const close = () => {
    history.replace(path.split('/').slice(0, -1).join('/').replace(':id', id)); // up one level
  };

  return (
    <ModalToBody>
      <div
        className="modal fade show"
        id="m_modal_4"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalLabel"
        style={{
          display: 'block',
          zIndex: 1039,
        }}
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                <Trans>Create Event Materials by Day</Trans>
              </h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={close}>
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div>
              <MaterialByDayForm
                materialId={parseInt(materialId, 10)}
                eventId={parseInt(id, 10)}
                onSubmitSuccess={close}
              />
            </div>
            {/*{showModal && (*/}
            {/*  <MaterialRequestForm*/}
            {/*    registration={registration}*/}
            {/*    material-requests={material-requests}*/}
            {/*    onSubmit={this._handleSubmit}*/}
            {/*    admin={admin}*/}
            {/*    event={event}*/}
            {/*  />*/}
            {/*)}*/}
          </div>
        </div>
      </div>

      <div
        className={'modal-backdrop fade show'}
        style={{
          display: 'block',
          zIndex: 1038,
        }}
      />
    </ModalToBody>
  );
};
